import { render } from "./FiltersFrame.vue?vue&type=template&id=7d952e62&scoped=true"
const script = {}

import "./FiltersFrame.vue?vue&type=style&index=0&id=7d952e62&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d952e62"]])

export default __exports__